import React from 'react';
import StateBlock from './StateBlock';

/**
 * Catches render-time crashes so one broken component shows a
 * recoverable message instead of unmounting the whole app to a
 * white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Kept as console output — there is no error-reporting service
    // wired up in this project.
    console.error('Unhandled UI error:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <StateBlock
          variant="error"
          title="Something went wrong"
          message="This section could not be displayed. Please try again, or head back to the homepage."
          actionLabel="Try again"
          onAction={this.handleReset}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
